.root {
  cursor: pointer;
  border-radius: 0 !important;
  transition: background-color 150ms ease;
}

.root:hover,
.root:active {
  background-color: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-4));
}

.root.unread {
  background-color: light-dark(var(--mantine-color-primary-0), var(--mantine-color-secondary-7));
}

.root.unread:hover,
.root.unread:active {
  background-color: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-4));
}

.root.unread .title {
  color: light-dark(var(--mantine-color-primary-7), var(--mantine-color-primary-2));
}
